import {
  Component,
  forwardRef,
  OnInit,
  ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ElasticemailSpecificSendingMailerConfiguration } from 'app/mediego-common-module/declarations/source';

@Component({
  selector: 'app-mediego-specific-sending-conf-elastic-email',
  templateUrl: './specific-sending-conf-elastic-email.component.html',
  styleUrls: ['./specific-sending-conf-elastic-email.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SpecificSendingConfElasticEmailComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SpecificSendingConfElasticEmailComponent
  implements ControlValueAccessor, OnInit
{
  elasticEmailForm: UntypedFormGroup;
  onTouched: any;

  defaultConf: ElasticemailSpecificSendingMailerConfiguration = {
    type: 'elastic-email',
    poolName: ''
  };

  get poolName(): UntypedFormControl {
    return this.elasticEmailForm?.get('poolName') as UntypedFormControl;
  }

  constructor(private _fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.elasticEmailForm = this._fb.group({
      type: this.defaultConf.type,
      poolName: this.defaultConf.poolName
    });

    this.elasticEmailForm.valueChanges.subscribe((value) => {
      this.onTouched?.();
    });
  }

  writeValue(obj: ElasticemailSpecificSendingMailerConfiguration): void {
    if (obj) {
      this.elasticEmailForm.setValue(obj);
    } else {
      this.elasticEmailForm.setValue(this.defaultConf);
    }
  }

  registerOnChange(fn: any): void {
    this.elasticEmailForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.elasticEmailForm.disable() : this.elasticEmailForm.enable();
  }

}
